import { Helmet } from "react-helmet-async";

export const SITE_URL =
  process.env.REACT_APP_SITE_URL || "https://travelclubnavigator.co";
export const SITE_NAME = "Travel Club Navigator Group";

export const SEO = ({
  title,
  description,
  image,
  path = "",
  keywords,
  jsonLd,
  type = "website",
  publishedTime,
  author,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Travel with Transparency`;
  const url = `${SITE_URL}${path}`;
  const kw = Array.isArray(keywords) ? keywords.join(", ") : keywords;
  const ldItems = Array.isArray(jsonLd) ? jsonLd.filter(Boolean) : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {kw && <meta name="keywords" content={kw} />}
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      {image && <meta property="og:image" content={image} />}
      <meta property="og:url" content={url} />
      {type === "article" && publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      {type === "article" && author && <meta property="article:author" content={author} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}

      {ldItems.map((item, i) => (
        <script key={`${item["@type"] || "ld"}-${i}`} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
};
